
export default (https) => ({
  async getList(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');

    const response = await https.get(`/platforms?${queryString}`);
    return response.data;
  },
  async add(payload) {
    const response = await https.post(`/platforms`, payload);
    return response.data;
  },

  async update(id, payload) {
    const response = await https.put(`/platforms/${id}`, payload);
    return response.data;
  },

  async deleteById(id) {
    const response = await https.delete(`/platforms/${id}`);
    return response.data;
  },
});

